import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./styles/default.less";
import "./styles/common.less";
import store from "./store/index";
import "./styles/transition.less";
import "./styles/antd.less";
import router from "./router";
import "./directive/index.js";
import { createAsyncGuard } from "./router/guard/index";
import * as Sentry from "@sentry/vue";
import SelfPagination from './components/SelfPagination.vue'
import ProductSelect from "@/components/ProductSelect";
import "./icons";
Vue.config.productionTip = false;
Vue.use(ElementUI);
createAsyncGuard(router);
Vue.component("SelfPagination", SelfPagination)
Vue.component("ProductSelect", ProductSelect);

if (process.env.NODE_ENV == "production") {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_URL,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "my-site-url.com", /^\//],
      }),
      new Sentry.Replay(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: 1.1 //选填
  });
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
